import React, { useState, useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../authcontext/AuthContext';
import TextBlock from '../form/blocks/TextBlock';
import axios from 'axios';
import { config } from '../../utils/config'

export default function AgentLogin() {

    const authData = useContext(AuthContext)
    const navigate = useNavigate();

    const [ceaNo, setCeaNo] = useState("");
    const [password, setPassword] = useState("");

    const verifyAgent = useCallback(async () => {


        try {
            const response = await axios.post(`${config.apiBaseUrl}/agent/login`, {
                ceaNo,
                password
            }, { withCredentials: true });

            console.log("access token:", response.data.accessToken)

            const token = response.data.accessToken
            authData.updateToken(token)

            if (token) {

                const agentData = await axios.get(`${config.apiBaseUrl}/user-login/profile`, {

                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }, { withCredentials: true });

                if (agentData) {
                    authData.updateUserDetail(agentData.data)
                    authData.updateIsAgentAuth(true)

                    navigate("/")

                } else {
                    console.log("unable to authenticate")
                }

            }

            // Handle the successful login response
        } catch (error) {

            console.log(error)
        }

    }, [password, ceaNo, authData, navigate])

    return (
        <>
            <div className="d-flex justify-content-center">
                <div className="container m-3" >
                    <h5>Agent Login</h5>
                    <TextBlock label={"CEA Number"} updateParentValue={(value) => { setCeaNo(value) }} />
                    <TextBlock label={"Password"} updateParentValue={(value) => { setPassword(value) }} />
                    <div>
                        <button className='btn btn-danger' onClick={verifyAgent}>Login</button>
                    </div>
                </div>
            </div>
        </>
    );
}

